import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import Home from './components/Home';
import PostTypeManager from './components/PostTypeManager';
import Login from './components/Login';
import Posts from './components/Posts';
import Profile from './components/Profile/Profile';
import ManageProfile from './components/Profile/ManageProfile';
import Sidebar from './components/Sidebar';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token); 
    setIsLoading(false);

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setIsDropdownOpen(false);
    // Optionally, redirect to home page after logout
    window.location.href = '/';
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  if (isLoading) {
    return <div>Loading...</div>; // Or any loading indicator
  }

  return (
    <Router>
      <div className="App">
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
          <div className="container">
            <Link className="navbar-brand" to="/">MedikaHub</Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav me-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/">Home</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/posts">Posts</Link>
                </li>
              </ul>
              <ul className="navbar-nav">
                <li className="nav-item dropdown" ref={dropdownRef}>
                  <button
                    className="nav-link dropdown-toggle btn btn-link"
                    onClick={toggleDropdown}
                    aria-expanded={isDropdownOpen}
                  >
                    {isLoggedIn ? 'Account' : 'Login'}
                  </button>
                  {isDropdownOpen && (
                    <ul className="dropdown-menu show dropdown-menu-end">
                      
                    {isLoggedIn ? (
                      <>
                        <li><Link className="dropdown-item" to="/profile" onClick={() => setIsDropdownOpen(false)}>Profile</Link></li>
                        {/* <li><Link className="dropdown-item" to="/manage-profile" onClick={() => setIsDropdownOpen(false)}>Manage Profile</Link></li> */}
                        <li><hr className="dropdown-divider" /></li>
                        <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
                      </>
                    ) : (
                      <li><Link className="dropdown-item" to="/login" onClick={() => setIsDropdownOpen(false)}>Login</Link></li>
                    )}
                  </ul>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="container-fluid mt-4">
          <div className="row">
            {isLoggedIn && (
              <div className="col-md-3">
                <Sidebar />
              </div>
            )}
                    <div className={`col-md-${isLoggedIn ? '9' : '12'}`}>

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
            <Route path="/posts" element={<Posts isLoggedIn={isLoggedIn} />} />
            <Route 
              path="/profile" 
              element={isLoggedIn ? <Profile /> : <Navigate to="/login" />} 
            />
            <Route 
              path="/manage-profile" 
              element={isLoggedIn ? <ManageProfile /> : <Navigate to="/login" />} 
            />
                    <Route path="/post-types" element={isLoggedIn ? <PostTypeManager /> : <Navigate to="/login" />}  />

          </Routes>
        </div>
        </div>
      </div>
      </div>
    </Router>
  );
}

export default App;
